import {Modalator} from 'hegyd/core/resources/assets/js/utils/Modalator.js'

export default class AddressBtn extends HTMLAnchorElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('click',  function(e){
            e.preventDefault();

            var url = this.dataset.href;
            var modal = new Modalator();

            modal.initRemoteModal('#modal-create-address', url, null, function (data) {
                if (data.hasOwnProperty('view')) {
                    document.querySelector('#addresses-list').innerHTML = data.view;
                }
            });
        });
    }
}
